module.exports = __webpack_public_path__ + "img/index_jiejue3.15c46dae.png";